import React, { memo } from "react";

const SingleCarTop = memo(function SingleCarTop(props) {
  return (
    <div className='single-car-top'>
      <div className='single-car-top-container'>
        <div className='single-car-top-img-container'>
          <img src={props.src} alt='img' />
        </div>
        <h5>{props.titulo}</h5>
      </div>
      <span>{props.span}</span>
    </div>
  )
})

export default SingleCarTop
